import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { debounce, interval, Subject, take, takeUntil } from 'rxjs';
import {
  NewsBannerModel,
  NewsBannerOrderModel,
} from '../../../../../models/news-banner.model';
import { NewsBannerService } from '../../../../../services/news-banner.service';

@Component({
  selector: 'app-news-banner-slide-sequence',
  templateUrl: './news-banner-slide-sequence.component.html',
  styleUrl: './news-banner-slide-sequence.component.scss',
  standalone: false,
})
export class NewsBannerSlideSequenceComponent implements OnInit, OnDestroy {
  @Input() newsBanners: NewsBannerModel[] = [];
  @Output() newsBannersChange: EventEmitter<NewsBannerModel[]> =
    new EventEmitter<NewsBannerModel[]>();

  private reorderSubject = new Subject<NewsBannerModel[]>();
  private destroy$ = new Subject<void>();

  constructor(private newsBannerService: NewsBannerService) {}

  ngOnInit(): void {
    this.reorderSubject
      .pipe(
        debounce(() => interval(700)),
        takeUntil(this.destroy$)
      )
      .subscribe((reorderedNewsBanners: NewsBannerModel[]) => {
        this.updateNewsBannerOrder(reorderedNewsBanners);
      });
  }

  onReorder(): void {
    this.reorderSubject.next(this.newsBanners);
  }

  private updateNewsBannerOrder(reorderedNewsBanners: NewsBannerModel[]): void {
    const reorderedNewsBannerOrder =
      this.createNewsBannerOrder(reorderedNewsBanners);

    this.newsBannerService
      .updateNewsBannerOrder(reorderedNewsBannerOrder)
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.newsBanners = reorderedNewsBanners;
          this.newsBannersChange.emit(reorderedNewsBanners);
          this.newsBanners.forEach((newsBanner, index) => {
            newsBanner.position = index + 1;
          });
        },
        error: () => {
          console.error('Failed to update news banner order');
        },
      });
  }

  private createNewsBannerOrder(
    reorderedNewsBanners: NewsBannerModel[]
  ): NewsBannerOrderModel[] {
    return reorderedNewsBanners.map(
      (newsBanner, index): NewsBannerOrderModel => {
        return {
          id: newsBanner.id,
          position: index + 1,
        };
      }
    );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
